import { Card, Input, Checkbox, Button } from "antd";
import { Printer, Save } from "lucide-react";
import { Stage, Layer, Circle, Image } from "react-konva";
import SignatureCanvas from "react-signature-canvas";
import useImage from "use-image";
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function TabDoctorExam() {
    const { t } = useTranslation();

    const [points, setPoints] = useState<any[]>([]);
    const [face] = useImage(
        "https://khothi.buso.asia/uploads/2025/09/photo_library/WZXKxW5DNl9d0eee4704d246866264109e17cf6005.PNG"
    );

    const sigCustomer = useRef<any>(null);
    const sigStaff = useRef<any>(null);

    const handleClick = (e: any) => {
        const stage = e.target.getStage();
        const pos = stage.getPointerPosition();
        setPoints([...points, pos]);
    };

    const [isDark, setIsDark] = useState(
        document.documentElement.classList.contains("dark")
    );

    useEffect(() => {
        const observer = new MutationObserver(() => {
            setIsDark(document.documentElement.classList.contains("dark"));
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["class"],
        });

        return () => observer.disconnect();
    }, []);

    return (
        <Card className="shadow-sm">

            {/* Alert */}

            <div className="bg-pink-50 dark:bg-pink-900/20 text-pink-600 dark:text-pink-300 text-sm p-3 rounded mb-4">
                {t('skin_care.doctor_note')}
            </div>

            <div className="grid grid-cols-12 gap-6">

                {/* LEFT */}

                <div className="col-span-12 lg:col-span-7">

                    {/* Tình trạng da */}

                    <div className="mb-6">

                        <div className="font-semibold mb-2 text-000000e0 dark:text-gray-200">
                            {t('skin_care.section_3_1')}
                        </div>

                        <Input.TextArea
                            rows={4}
                            placeholder={t('skin_care.section_3_1_placeholder')}
                        />

                    </div>

                    {/* Hướng điều trị */}

                    <div className="mb-6">

                        <div className="font-semibold mb-3 text-000000e0 dark:text-gray-200">
                            {t('skin_care.section_3_2')}
                        </div>

                        {/* Nâng cơ */}

                        <Card size="small" className="mb-4">

                            <div className="font-medium text-pink-600 mb-3">
                                {t('skin_care.lift_wrinkle')}
                            </div>

                            <Checkbox.Group
                                options={[
                                    { label: t('skin_care.thermage'), value: "thermage" },
                                    { label: "Ultherapy", value: "ultherapy" },
                                    { label: t('skin_care.botox'), value: "botox" },
                                    { label: t('skin_care.filler'), value: "filler" },
                                ]}
                                className="grid grid-cols-1 sm:grid-cols-2 gap-2"
                            />

                        </Card>

                        {/* Treatment groups */}

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">

                            <Card size="small" title="Laser">

                                <Checkbox.Group
                                    options={[
                                        { label: "Pico", value: "pico" },
                                        { label: "Skin Booster", value: "skin_booster" },
                                        { label: "Young", value: "young" },
                                        { label: "Filling", value: "filling" },
                                    ]}
                                    className="flex flex-col gap-1"
                                />

                            </Card>

                            <Card size="small" title={t('skin_care.regeneration')}>

                                <Checkbox.Group
                                    options={[
                                        { label: t('skin_care.microneedling'), value: "lan_kim" },
                                        { label: t('skin_care.algae'), value: "tao" },
                                        { label: t('skin_care.melasma'), value: "nam_hac_mai" },
                                    ]}
                                    className="flex flex-col gap-1"
                                />

                            </Card>

                            <Card size="small" title={t('skin_care.care_nourish')}>

                                <Checkbox.Group
                                    options={[
                                        { label: t('skin_care.essence'), value: "tinh_thuy_quang" },
                                        { label: "PRP", value: "prp" },
                                        { label: t('skin_care.detox'), value: "detox" },
                                        { label: "Massage", value: "massage" },
                                    ]}
                                    className="flex flex-col gap-1"
                                />

                            </Card>

                        </div>

                    </div>

                    {/* Notes */}

                    <div>

                        <div className="font-semibold mb-2 text-000000e0 dark:text-gray-200">
                            {t('skin_care.notes_products')}
                        </div>

                        <Input.TextArea rows={3} />

                    </div>

                </div>

                {/* RIGHT */}

                <div className="col-span-12 lg:col-span-5">

                    <Card className="sticky top-4">

                        <div className="text-center font-semibold mb-4 text-000000e0 dark:text-gray-200">
                            {t('skin_care.face_map')}
                        </div>

                        <div className="border border-dashed border-pink-300 rounded flex justify-center overflow-x-auto">

                            <Stage width={220} height={280} onClick={handleClick}>

                                <Layer>

                                    <Image image={face} width={220} height={280} />

                                    {points.map((p, i) => (

                                        <Circle
                                            key={i}
                                            x={p.x}
                                            y={p.y}
                                            radius={5}
                                            fill="red"
                                            onClick={(e) => {
                                                e.cancelBubble = true;
                                                const newPoints = points.filter((_, index) => index !== i);
                                                setPoints(newPoints);
                                            }}
                                        />

                                    ))}

                                </Layer>

                            </Stage>

                        </div>

                        <div className="text-center text-xs text-gray-500 mt-2">
                            {t('skin_care.face_click_mark')}
                        </div>

                        <div className="text-center text-xs text-gray-500 mt-1">
                            {t('skin_care.face_click_remove')}
                        </div>

                        <div className="flex justify-center mt-3">

                            <Button
                                size="small"
                                onClick={() => setPoints([])}
                            >
                                {t('skin_care.clear_all')}
                            </Button>

                        </div>

                        {/* Signature */}

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">

                            {/* Customer */}

                            <div>

                                <SignatureCanvas
                                    key={isDark ? "dark" : "light"}
                                    ref={sigCustomer}
                                    penColor={isDark ? "#ffffff" : "#000000"}
                                    canvasProps={{
                                        className:
                                            "border rounded w-full h-[80px] bg-white dark:bg-slate-900",
                                    }}
                                />

                                <div className="text-center text-xs mt-1 text-000000e0 dark:text-gray-200">
                                    {t('skin_care.customer_signature')}
                                </div>

                                <Button
                                    className="mt-2 w-full"
                                    onClick={() => sigCustomer.current.clear()}
                                >
                                    {t('skin_care.clear_signature')}
                                </Button>

                            </div>

                            {/* Staff */}

                            <div>

                                <SignatureCanvas
                                    key={isDark ? "dark" : "light"}
                                    ref={sigStaff}
                                    penColor={isDark ? "#ffffff" : "#000000"}
                                    canvasProps={{
                                        className:
                                            "border rounded w-full h-[80px] bg-white dark:bg-slate-900",
                                    }}
                                />

                                <div className="text-center text-xs mt-1 text-000000e0 dark:text-gray-200">
                                    {t('skin_care.staff_signature')}
                                </div>

                                <Button
                                    className="mt-2 w-full"
                                    onClick={() => sigStaff.current.clear()}
                                >
                                    {t('skin_care.clear_signature')}
                                </Button>

                            </div>

                        </div>

                    </Card>

                </div>

            </div>

            {/* Footer */}

            <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">

                <Button icon={<Printer size={16} />}>
                    {t('skin_care.print')}
                </Button>

                <Button type="primary" icon={<Save size={16} />}>
                    {t('skin_care.save')}
                </Button>

            </div>

        </Card>
    );
}